(function () {
  'use strict';
  const root = document.documentElement;
  const suppressNewsletter = () => {
    if (!root.classList.contains('pb-purchase-flow')) return;
    const popup = document.getElementById('theMarketer-popup-backdrop');
    const close = popup?.querySelector('button.mkt-popup-close');
    if (close && !popup.dataset.pbDismissed) {
      popup.dataset.pbDismissed = 'true';
      close.click(); // Let the provider restore focus and scroll state.
    }
  };
  const purchase = () => {
    root.classList.add('pb-purchase-flow');
    try { sessionStorage.setItem('pb-purchase-flow', '1'); } catch (_) {}
    suppressNewsletter();
  };
  document.addEventListener('click', event => {
    if (event.target.closest('pb-card-shades, pb-compatible-activator, pb-cro-set, form[action*="/cart/add"], a[href$="/cart"]')) purchase();
  }, true);
  new MutationObserver(suppressNewsletter).observe(document.body, { childList:true, subtree:true });
  suppressNewsletter();

  if (customElements.get('pb-compatible-activator')) return;
  class CompatibleActivator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const hu = this.dataset.language === 'hu';
      this.copy = hu ? {
        add:'Aktivátor a kosárba', busy:'Hozzáadás…', done:'Az aktivátor a kosárba került. A festéket külön add hozzá.',
        error:'Ellenőrizd a kosarat, majd frissítsd az oldalt az újabb próbálkozás előtt.'
      } : {
        add:'Adaugă activatorul', busy:'Se adaugă…', done:'Activatorul a fost adăugat în coș. Adaugă separat vopseaua.',
        error:'Verifică produsele din coș și reîncarcă pagina înainte de a încerca din nou.'
      };
      this.select = this.querySelector('[data-activator-variant]');
      this.quantity = this.querySelector('[data-activator-quantity]');
      this.button = this.querySelector('[data-activator-add]');
      this.message = this.querySelector('[data-activator-message]');
      this.select.addEventListener('change', () => {
        const option = this.select.selectedOptions[0];
        this.quantity.min = option.dataset.min || '1';
        this.quantity.step = option.dataset.step || '1';
        this.quantity.max = option.dataset.max || '';
        this.quantity.value = this.quantity.min;
        this.message.textContent = '';
        this.update();
      });
      this.quantity.addEventListener('input', () => this.update());
      this.button.addEventListener('click', () => this.add());
      this.update();
    }
    update() {
      this.button.disabled = !!this.busy || !!this.locked || !this.select.value || !this.quantity.checkValidity() || !Number.isSafeInteger(Number(this.quantity.value)) || Number(this.quantity.value) < 1;
      this.button.textContent = this.busy ? this.copy.busy : this.copy.add;
      this.button.setAttribute('aria-busy', String(!!this.busy));
    }
    async add() {
      if (this.button.disabled) return;
      purchase();
      if (!window.PBCroCart) { this.message.textContent = this.copy.error; return; }
      this.busy = true;
      this.update();
      try {
        const result = await window.PBCroCart.add(new Map([[this.select.value, Number(this.quantity.value)]]), 'product');
        this.locked = !result?.complete;
        this.message.textContent = result?.complete ? this.copy.done : this.copy.error;
      } catch (_) {
        this.locked = true;
        this.message.textContent = this.copy.error;
      } finally { this.busy = false; this.update(); }
    }
  }
  customElements.define('pb-compatible-activator', CompatibleActivator);
})();
